import { useQuery } from '@tanstack/react-query'

import { getLevelList, GetLevelListRequest } from '../../api/level'
import { QUERY_KEYS } from '../../constants/queryKeys'

function useGetLevelList(request?: GetLevelListRequest, filter: boolean = false, defaultLevel?: string) {
   return useQuery({
      queryKey: [QUERY_KEYS.GET_LEVEL_LIST, request, filter],
      queryFn: async () => {
         const result = await getLevelList(request)
         if (filter) {
            const filtered = result.items.filter((item) => (item.name ?? '').trim().toLowerCase() === (defaultLevel ?? '').toLowerCase())
            return {
               items: filtered,
               totalSize: filtered.length,
            }
         }
         return {
            items: result.items,
            totalSize: result.totalSize,
         }
      },
      enabled: !!request?.loyaltyPlanIds && (filter ? !!defaultLevel : true),
   })
}

export { useGetLevelList }
export default useGetLevelList
